"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionDataInputSchema = exports.PromotionDataSchema = exports.PromotionKey = void 0;
var zod_1 = require("zod");
exports.PromotionKey = {
    MILLION_COUPON_231027: 'MILLION_COUPON_231027',
    MILLION_COUPON_240207: 'MILLION_COUPON_240207',
    MILLION_COUPON_240227: 'MILLION_COUPON_240227',
    MILLION_COUPON_240603: 'MILLION_COUPON_240603',
    MILLION_COUPON_240827: 'MILLION_COUPON_240827',
    MILLION_COUPON_250228: 'MILLION_COUPON_250228',
    MILLION_COUPON_250528: 'MILLION_COUPON_250528',
};
exports.PromotionDataSchema = zod_1.z.object({
    memberNo: zod_1.z.number(),
    type: zod_1.z.nativeEnum(exports.PromotionKey),
    data: zod_1.z.object({
        city: zod_1.z.string().nullable(),
        region: zod_1.z.string().nullable(),
    }),
    registerDate: zod_1.z.string(),
});
exports.PromotionDataInputSchema = exports.PromotionDataSchema.pick({ data: true, type: true });
